export class ConfigurationSide {
  id: string;
  name: string;
  length: number;
  hasFinishing: boolean;
  finishingLength: number;
}
